export default function OpportunityDetails({ opportunity }) {
  return [opportunity.name, opportunity.company?.name].filter(Boolean).join(' - ');
}
